import { PriceService } from '../services/price.service';

const actions = {
  /**
   * Create price
   */
  // eslint-disable-next-line
  createPrice: async ({}, payload) => {
    try {
      const price = await PriceService.createPrice(payload);
      return price;
    } catch (e) {
      return false;
    }
  },
  /**
   * Update price
   */
  // eslint-disable-next-line
  updatePrice: async ({}, { id, payload }) => {
    try {
      const price = await PriceService.updatePrice(id, payload);
      return price;
    } catch (e) {
      return false;
    }
  },
  /**
   * Delete price
   */
  // eslint-disable-next-line
  deletePrice: async ({}, id) => {
    try {
      await PriceService.deletePrice(id);
      return true;
    } catch (e) {
      return false;
    }
  },
};

export default {
  namespaced: true,
  actions,
};
